// @codekit-prepend "../node_modules/jquery/dist/jquery.js"; // quiet
// @codekit-prepend "../node_modules/foundation-sites/dist/js/foundation.min.js"; // quiet
// @codekit-prepend "../node_modules/what-input/dist/what-input.js"; // quiet

"use strict";$(document).foundation();
//# sourceMappingURL=app.js.map


jQuery(document).ready(function( $ ) {

    $("#open-menu").click(function () {
        $("#mobile-menu").addClass('active');
        $("#close-overlay").addClass('active');
    });
    $("#close-menu").click(function () {
        $("#mobile-menu").removeClass('active');
        $("#close-overlay").removeClass('active');
    });
    $("#close-overlay").click(function () {
        $("#mobile-menu").removeClass('active');
        $("#close-overlay").removeClass('active');
    });

    $(document).on('scroll', function () {
        var scroll = $(window).scrollTop();
        if (scroll > 150) $('.scroll-top-wrapper').addClass('show');
        else
        $('.scroll-top-wrapper').removeClass('show');
    });


  $(window).on('scroll touchmove resize', function () {
        hasScrolled();
    });

    function hasScrolled() {
        var wh = $(window).height();
        var dh = $(document).height();
        var fh = $("#footer").height();
        var st = $(window).scrollTop();
        var asp = $("#asp-formfix");
        var offset = dh - wh - fh;

        var scro = $(".scroll-top-wrapper a");


        //                console.log("r:" + offset + "st:" + st);

        if (st + wh <= dh - fh || st == 0) {
            asp.css({'bottom': '0' });
            scro.css({'bottom': '0' });
        } else {
            asp.css({'bottom': '' + (st - offset) + 'px' });
            scro.css({'bottom': '' + (st - offset - 1) + 'px' });
        }

    }
    hasScrolled();


$(window).bind("load", function () {
    var form = $("#asp-formfix");
    var overlay = $("#asp-formfix-overlay");
    var container = $("#container");
    var height = $(window).height();
    var headerheight = $("#header").height();

    container.css({
        'min-height': '' + (height - headerheight - 80) + 'px'
    });


    $("#asp-formfix-toggle").click(function () {
        form.toggleClass('active');
        overlay.toggleClass('active');
        //lockScroll(true);
    });
    $(overlay).click(function () {
        form.toggleClass('active');
        overlay.toggleClass('active');
        //lockScroll(false);
    });

    // function lockScroll(tr) {
    //     if (tr) {
    //         $('html, body').css({
    //             overflow: 'hidden',
    //             height: '100%'
    //         });
    //     } else {
    //         $('html, body').css({
    //             overflow: 'auto',
    //             height: 'auto'
    //         });
    //     }
    // }

});

});
